"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FadeAnimation = void 0;

var _styledComponents = require("styled-components");

var _InOutAnimation = require("./InOutAnimation");

var fadeAnimationBase = (0, _styledComponents.css)(["transition:", ";opacity:0;"], function (props) {
  return (0, _styledComponents.css)(["opacity ", "ms"], props.duration);
});
var fadeAnimationEnter = (0, _styledComponents.css)(["opacity:1;transform:translateY(0) translateX(0);"]);
var fadeAnimationExit = (0, _styledComponents.css)(["opacity:0;"]);
var FadeAnimation = (0, _InOutAnimation.createInOutAnimation)({
  baseStyles: fadeAnimationBase,
  enterStyles: fadeAnimationEnter,
  exitStyles: fadeAnimationExit
});
exports.FadeAnimation = FadeAnimation;